import { useMemoBuyerNickMask } from 'services/channels/demo';
import { Tooltip } from 'antd';
import { useTransAppProductName } from 'hooks/useTrans';
import Icon from '@ant-design/icons';
import { ReactComponent as ContactFill } from '../../assets/contact-fill.svg';
import { ContactBuyer, ContactBuyerProps } from '../ContactBuyer';
import { ReturnOrderListItemV2 } from 'services/api/refund';
import { toUpperCase } from 'utils/toLowerCase';

interface BuyerInfoProps
  extends Omit<
    ContactBuyerProps,
    | 'children'
    | 'orderSn'
    | 'region'
    | 'externalBuyerId'
    | 'externalStoreId'
    | 'buyerNick'
    | 'returnSn'
    | 'reverseOrderId'
  > {
  contactEnable?: boolean;
  row: ReturnOrderListItemV2;
}

export const BuyerInfo = (props: BuyerInfoProps) => {
  const { row, contactEnable, ...rest } = props;
  const {
    buyerNick: buyerNickRaw,
    orderSn,
    region,
    externalBuyerId,
    externalStoreId,
    returnSn,
  } = row;

  const appProductNameT = useTransAppProductName();
  const buyerNick = useMemoBuyerNickMask(buyerNickRaw);

  if (contactEnable) {
    return (
      <ContactBuyer
        {...rest}
        orderSn={orderSn}
        region={toUpperCase(region) as General.UpperCaseRegion}
        externalBuyerId={externalBuyerId}
        externalStoreId={externalStoreId}
        buyerNick={buyerNick}
        returnSn={returnSn}
      >
        {({ onClick }) => (
          <Tooltip title={appProductNameT('tableColumn.contactBuyerNow')}>
            <div
              className="flex rounded-sm cursor-pointer items-center gap-1 h-[24px] px-[10px] border border-solid border-[#D3D7E0] bg-[#FFFFFF]"
              onClick={() => {
                if (contactEnable) {
                  onClick();
                }
              }}
            >
              {buyerNick ? (
                <div className="max-w-[110px] text-ellipsis overflow-hidden whitespace-nowrap">
                  {buyerNick}
                </div>
              ) : null}
              {contactEnable && <Icon component={ContactFill} />}
            </div>
          </Tooltip>
        )}
      </ContactBuyer>
    );
  }

  return (
    <div className="flex rounded-sm cursor-pointer items-center gap-1 h-[24px] px-[10px] border border-solid border-[#D3D7E0] bg-[#FFFFFF]">
      <div className="max-w-[110px] text-ellipsis overflow-hidden whitespace-nowrap">
        {buyerNick}
      </div>
    </div>
  );
};
